import { access } from '@driftt/traffic-control'

import { isNilOrEmpty } from 'utils'

import {
  ELOQUA_APP_ID,
  PARDOT_APP_ID,
  PIESYNC_APP_ID,
} from '../constants/ResourceConstants'

export const { hasGates, hasAnyRole, isAdmin, hasFeatures, hasAnyDefaultRole } =
  access

export const Gates = {
  PREMIUM: 'premium_drift',
  PREMIUM_TEAM: 'premium_team',
  PREMIUM_ENTERPRISE: 'premium_enterprise',
  PLAYBOOKS: 'PLAYBOOKS',
  LEGACY_ROUTINGBOT: 'has_legacy_routingbot',
  PLAYBOOKS_DEV: 'has_playbooks_dev',
  MARKETO: 'marketo',
  ELOQUA: 'HAS_ELOQUA',
  PARDOT: 'HAS_PARDOT',
  DEMANDBASE: 'demandbase',
  UNLIMITED_SEATS: 'hasUnlimitedSeats',
  SALESFORCE_EVENTS: 'hasSalesforceEvents',
  KNOWLEDGE_BASE: 'has_grandfathered_knowledgebase',
  STANDARD_APRIL_2018: 'standard_04_2018',
  CLEARBIT_SETTINGS: 'clearbit_settings',
  SAVED_REPLIES: 'saved_replies',
  CALENDAR_DROP: 'calendar_drop',
  CALENDAR_INTEGRATION: 'calendar_integration',
  GRANDFATHERED_CALENDAR_INTEGRATION: 'has_meetings',
  HUBSPOT_INSTALL: 'has_hubspot_install',
  OUTREACH_BETA: 'has_outreach_beta',
  OUTREACH: 'has_outreach',
  HAS_PIESYNC: 'HAS_PIESYNC',
  LEANDATA: 'has_leandata',
  STRIPE: 'has_transaction_in_conversation',
  WEBSOCKET_CHAT_NOTIFS: 'web_socket_chat_notifications',
  SIFTROCK_BOTS_V2: 'has_siftrock_bots_v2',
  SIFTROCK_BOTS_V2_EXISTING_ORG: 'has_siftrock_bots_v2_existing_org',
  HAS_ZOOM_MEETINGS: 'has_zoom_meetings',
  TEAM_VIDEO_LICENSE: 'has_team_video_license',
  HAS_MICROSOFT_DYNAMICS: 'has_microsoft_dynamics',
}

const createDevDriftMap = () => {
  const gateMap = {}
  gateMap[ELOQUA_APP_ID] = 'HAS_ELOQUA'
  gateMap[PARDOT_APP_ID] = 'HAS_PARDOT'
  gateMap[PIESYNC_APP_ID] = 'HAS_PIESYNC'
  return gateMap
}

export const DriftDevIntegrationGates = createDevDriftMap()
export const canBeAssignedOrgOwner = ({ scopes, workspaceRoles }) => {
  return (
    (!!scopes && scopes.includes('org_admin')) ||
    (!isNilOrEmpty(workspaceRoles) &&
      workspaceRoles.find((role) => !!role.adminRole))
  )
}
export const canReceiveDataPrivacyNotifications = ({
  scopes,
  workspaceRoles,
  bot,
}) => {
  return (
    ((!!scopes && scopes.includes('org_admin')) ||
      (!isNilOrEmpty(workspaceRoles) &&
        workspaceRoles.find((role) => !!role.adminRole))) &&
    !bot
  )
}

export const isVideoAdmin = () => {
  return hasGates(Gates.TEAM_VIDEO_LICENSE) && hasAnyRole('Video Admin')
}

export const isChatAdmin = () => isAdmin()

export const isAnyAdmin = () => isChatAdmin() || hasAnyRole('Video Admin')

export const canUpgradePlan = () =>
  isAdmin() ||
  hasFeatures({ featureName: 'plan_and_billing', accessLevel: 'WRITE' })
export const canWriteSavedReplies = () =>
  isAdmin() ||
  hasFeatures({ featureName: 'saved_replies', accessLevel: 'WRITE' })
export const canWriteWidgetSettings = () =>
  isAdmin() ||
  hasFeatures({ featureName: 'widget_settings', accessLevel: 'WRITE' })
export const canWriteEmailPlaybooks = () =>
  isAdmin() ||
  hasFeatures({ featureName: 'email_playbooks', accessLevel: 'WRITE' })
export const canWriteSignaturePlaybooks = () =>
  isAdmin() ||
  hasFeatures({ featureName: 'signature_playbooks', accessLevel: 'WRITE' })
export const canReadManageTeammates = () =>
  isAdmin() ||
  hasFeatures({ featureName: 'manage_teammates', accessLevel: 'READ' })
export const canWriteOrgIntegrationSettings = () =>
  isAdmin() ||
  hasFeatures({ featureName: 'org_integrations', accessLevel: 'WRITE' })
export const canReadOrgIntegrationSettings = () =>
  isAdmin() ||
  hasFeatures({ featureName: 'org_integrations', accessLevel: 'READ' })
export const canReadHelpDocs = () =>
  isAdmin() || hasFeatures({ featureName: 'help_docs', accessLevel: 'READ' })

export const canConfigureDealroom = () =>
  hasFeatures({ featureName: 'has_deal_room', accessLevel: 'WRITE' })
export const hasWorkspaces = () =>
  !isNilOrEmpty(
    access
      .getWorkspacesWithPermission('workspace_settings', 'WRITE')
      .filter((workspace) => workspace !== 'default')
  )
export const hasProfile = () =>
  hasFeatures({ featureName: 'profile', accessLevel: 'WRITE' })
